import mixComponent from './mixComponent.vue'
export default function(conf){
    let store = this.$store;
    if(conf.componentType == 'publicComponent'){
      if(conf.componentCode=="scccContactContent"){
        return store.state.dynamicComponent.DIYLAYOUT['mixin_scccContactContent'];
      }
        return store.state.dynamicComponent.DIYLAYOUT[conf.componentCode];
    }else{
        return mixComponent;
    }
}